import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import styles from "css/mobile/mypage.module.css";
import { useTranslation } from "react-i18next";
import ScheduleCard from "components/mobile/mypage/ScheduleCard";
import moment from "moment";
import "css/menu.css";
import { useDispatch } from "react-redux";
import { closeAlert, openAlert } from "redux/slices/alertSlice";
import Input from "antd/es/input/Input";
import { Button } from "antd";
import FavoriteResPop from "components/mobile/mypage/FavoriteResPop";
import ResPop from "components/mobile/mypage/ResPop";
import DetailParticipantPop from "components/mobile/mypage/DetailParticipantPop";

export default function FavoriteSchedules() {
  const [type] = useState("favorite");
  const [isOpenFavRes, setIsOpenFavRes] = useState(false);
  const [isOpenRes, setIsOpenRes] = useState(false);
  const [isOpenParticipantDetail, setIsOpenParticipantDetail] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState({});
  const [updatedSchedule, setUpdatedSchedule] = useState({});
  const [favorites, setFavorites] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [keyword, setKeyword] = useState("");
  const [initSchedule, setInitSchedule] = useState({
    PROCESS_TYPE: "C",
    TITLE: "",
    CONTENTS: "",
    OPEN_YN: "Y",
    RECORD_YN: "N",
    MAIL_YN: "Y",
    MEETING_PW: "",
    PARTICIPANT_LIST: [],
    ENDPOINT_LIST: [],
    ATTACHMENT_LIST: [],
  });

  const dispatch = useDispatch();
  const { t } = useTranslation();
  moment.locale("en");

  const getFavorites = useCallback(() => {
    const startDate = new Date();
    const endDate = new Date(startDate.getTime() + 31 * 24 * 60 * 60 * 1000); // after a month

    let config = {
      params: {
        ACTIVE_START: moment(startDate).format("YYYY-MM-DD HH:mm:ss"),
        ACTIVE_END: moment(endDate).format("YYYY-MM-DD HH:mm:ss"),
        CALENDAR_TYPE: "MY",
        KEY_WORD: keyword,
      },
    };

    axios
      .get("/schedule/favorites", config)
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          setFavorites(res.data);
        }
      })
      .catch(() => {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ERROR_OCCURRED"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [dispatch, t, keyword]);

  const deleteFavorite = (info) => {
    let params = {
      FAVORITES_ID: info.FAVORITES_ID,
    };
    axios
      .put("/schedule/deletefavorite", params)
      .then((res) => {
        if (res.status === 200) {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: t("MESSAGE.DELETE_COMPLETE"),
            submitEventHandler: () => {
              getFavorites();
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
        }
      })
      .catch((error) => {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ERROR_OCCURRED"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      });
    closeFavRes();
  };

  const handleSearch = (value) => {
    setKeyword(value);
    setIsLoading(true);
  };

  useEffect(() => {
    if (isLoading) {
      getFavorites();
    }
  }, [getFavorites, isLoading]);

  // 줄겨찾기페이지용 이벤트 (create, update, dleete 버튼)
  const openFavRes = (schedule, PROCESS_TYPE) => {
    if (PROCESS_TYPE === "U") {
      setSelectedSchedule({
        ...schedule,
        PROCESS_TYPE: "U",
      });
      setIsOpenFavRes(true);
    } else {
      setSelectedSchedule(initSchedule);
      setIsOpenFavRes(true);
    }
  };

  const closeFavRes = () => {
    setIsOpenFavRes(false);
  };

  const closeRes = () => {
    setIsOpenRes(false);
  };

  const closeParticipantDetail = (e) => {
    e.stopPropagation();
    setIsOpenParticipantDetail(false);
  };

  return (
    <>
      <ResPop
        isOpenRes={isOpenRes}
        close={closeRes}
        schedule={updatedSchedule}
        getScheduleList={getFavorites}
        PAGE_TYPE="calendar"
        RES_TYPE="general"
      />
      <FavoriteResPop
        key={selectedSchedule.FAVORITE_ID}
        isOpenFavRes={isOpenFavRes}
        closeFavRes={closeFavRes}
        schedule={selectedSchedule}
        setIsOpenRes={setIsOpenRes}
        setUpdatedSchedule={setUpdatedSchedule}
        deleteFavorite={deleteFavorite}
        getScheduleList={getFavorites}
        PAGE_TYPE="calendar"
        RES_TYPE="general"
      />
      <DetailParticipantPop
        isOpenParticipantDetail={isOpenParticipantDetail}
        closeParticipantDetail={closeParticipantDetail}
        participants={selectedSchedule.PARTICIPANT_LIST}
      />
      <div className={styles.container}>
        <div className={styles.searchArea}>
          <Input
            placeholder={t("PLACEHOLDER.SEARCH.TITLE_CONTENT_SHORT")}
            value={keyword}
            onChange={(e) => handleSearch(e.target.value)}
            className={styles.searchBox}
          />
        </div>
        {favorites.length > 0 && (
          <div className={styles.total}>
            {t("LABEL.ALL")} {favorites.length}
          </div>
        )}
        <div className={styles.cardArea}>
          {isLoading ? (
            <div key="loading">{t("LABEL.PROCESS_DATA")}</div>
          ) : (
            <>
              {favorites.length === 0 && (
                <div key="no-data">{t("LABEL.NO_DATA")}</div>
              )}

              {favorites.length > 0 &&
                favorites.map((favorite, index) => {
                  return (
                    <ScheduleCard
                      key={favorite.FAVORITES_ID}
                      schedule={favorite}
                      type={type}
                      refresh={handleSearch}
                      setSelectedSchedule={setSelectedSchedule}
                      setIsOpenParticipantDetail={setIsOpenParticipantDetail}
                      openFavRes={openFavRes}
                      deleteFavorite={deleteFavorite}
                    />
                  );
                })}
            </>
          )}
          <Button
            className={styles.fovoriteAddBtn}
            onClick={() => openFavRes(initSchedule, "C")}
          >
            {t("BTN.CREATE_FAV_MEETING")}
          </Button>
        </div>
      </div>
    </>
  );
}
